import stepsLive from './formGroupLiveSteps/formGroup0LiveSteps';

import formGroup1Status from './formGroupLiveSteps/formGroupStep5Status/formGroup1Status';

export default {
  title: 'Live event Creation',
  attributeName: 'live',
  createURL: 'live',
  sessionParams: [],
  getURL: 'live',
  updateURL: 'live',
  idAttribute: 'id',
  noArea: true,
  goBack: true,
  autoUpdate: true,
  formConfig: [
    formGroup1Status,
  ],
  stepConfig: stepsLive,
  
};
